import { createContext } from "react";
const flags = {
    providerAvailabilityFlag:
        process.env.REACT_APP_FF_PROVIDER_AVAILABILITY === "true",
    displayOngoingMaintenanceMessage:
        process.env.REACT_APP_FF_ONGOING_MAINTENANCE === "true",
    displayUpcomingMaintenanceMessage:
        process.env.REACT_APP_FF_UPCOMING_MAINTENANCE === "true",
    displayNewBookingsFlag: process.env.REACT_APP_FF_NEW_BOOKINGS === "true",
    displayNewServicesFlag: process.env.REACT_APP_FF_NEW_SERVICES === "true"
};
export const FlagsContext = createContext(flags);
const FlagsProvider = ({ children }) => {
    return (
        <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
    );
};
export default FlagsProvider;
